import * as types from './ProgramsTypes';

export default function ProgramsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PROGRAMS_CATEGORIES:
            return {
                ...state,
                getProgramsCategories: {
                    ...state.getProgramsCategories,
                    programsCategories: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PROGRAMS_CATEGORIES_LOADING:
            return {
                ...state,
                getProgramsCategories: {
                    ...state.getProgramsCategories,
                    loading: true
                },
            };
        case types.GET_PROGRAMS_CATEGORIES_ERROR:
            return {
                ...state,
                getProgramsCategories: {
                    ...state.getProgramsCategories,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROGRAMS:
            return {
                ...state,
                getPrograms: {
                    ...state.getPrograms,
                    programs: payload.data,
                    firstProgram: payload.first,
                    lastProgram: payload.last,
                    nextPrograms: payload.next,
                    programsFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PROGRAMS_LOADING:
            return {
                ...state,
                getPrograms: {
                    ...state.getPrograms,
                    loading: true
                },
            };
        case types.GET_PROGRAMS_ERROR:
            return {
                ...state,
                getPrograms: {
                    ...state.getPrograms,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PROGRAM_BY_ID:
            return {
                ...state,
                getProgramById: {
                    ...state.getProgramById,
                    program: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PROGRAM_BY_ID_LOADING:
            return {
                ...state,
                getProgramById: {
                    ...state.getProgramById,
                    loading: true
                },
            };
        case types.GET_PROGRAM_BY_ID_ERROR:
            return {
                ...state,
                getProgramById: {
                    ...state.getProgramById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_PROGRAM:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PROGRAM_LOADING:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: true
                },
            };
        case types.CREATE_PROGRAM_ERROR:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_PROGRAMS_WITH_EXCEL:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PROGRAMS_WITH_EXCEL_LOADING:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: true
                },
            };
        case types.CREATE_PROGRAMS_WITH_EXCEL_ERROR:
            return {
                ...state,
                createProgram: {
                    ...state.createProgram,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PROGRAM:
            return {
                ...state,
                updateProgram: {
                    ...state.updateProgram,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PROGRAM_LOADING:
            return {
                ...state,
                updateProgram: {
                    ...state.updateProgram,
                    loading: true
                },
            };
        case types.UPDATE_PROGRAM_ERROR:
            return {
                ...state,
                updateProgram: {
                    ...state.updateProgram,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_PROGRAM:
            return {
                ...state,
                deleteProgram: {
                    ...state.deleteProgram,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.DELETE_PROGRAM_LOADING:
            return {
                ...state,
                deleteProgram: {
                    ...state.deleteProgram,
                    loading: true
                },
            };
        case types.DELETE_PROGRAM_ERROR:
            return {
                ...state,
                deleteProgram: {
                    ...state.deleteProgram,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_PROGRAM_RESET_STATE:
            return {
                ...state,
                deleteProgram: {
                    ...state.deleteProgram,
                    deleteProgram: {
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    }
                },
            };
        case types.UPDATE_PROGRAM_STATUS:
            return {
                ...state,
                updateProgramStatus: {
                    ...state.updateProgramStatus,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PROGRAM_STATUS_LOADING:
            return {
                ...state,
                updateProgramStatus: {
                    ...state.updateProgramStatus,
                    loading: true
                },
            };
        case types.UPDATE_PROGRAM_STATUS_ERROR:
            return {
                ...state,
                updateProgramStatus: {
                    ...state.updateProgramStatus,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PROGRAM_STATUS_RESET_STATE:
            return {
                ...state,
                updateProgramStatus: {
                    ...state.updateProgramStatus,
                    updateProgramStatus: {
                        loading: false,
                        hasSuccess: false,
                        hasError: {
                            code: null,
                            message: null
                        }
                    }
                },
            };
        case types.PROGRAMS_RESET_STATE:
            return {
                getProgramsCategories: {
                    programsCategories: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPrograms: {
                    programs: [],
                    firstProgram: null,
                    lastProgram: null,
                    nextPrograms: null,
                    programsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                createProgram: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
    
        default:
            return state;
    }
}